import {
  Button,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import useAddUsers from "./useAddUser";
import Style from "../aiSettings.module.scss";

const AddUsers = ({ aiSettingsState, setAiSettingsState, refetch }) => {
  const {
    formik,
    handleCloseModal,
    getFieldError,
    handleAddSelectedUser,
    handleRemoveSelectedUser,
  } = useAddUsers({
    aiSettingsState,
    setAiSettingsState,
    refetch,
  });

  return (
    <div className="row">
      <Input
        label={"Icon Percentage"}
        type="text"
        id="icon_percentage"
        name="icon_percentage"
        className={`pro-input lg ${
          getFieldError("icon_percentage") && "error"
        }`}
        {...formik.getFieldProps("icon_percentage")}
        onChange={(e) =>
          formik.setFieldValue("icon_percentage", e.target.value)
        }
        error={getFieldError("icon_percentage")}
        errorMessage={getFieldError("icon_percentage")}
      />
      <>
        <div className={Style.add_wrap}>
          <Input
            label={"Add Users"}
            type="text"
            id="add_user"
            name="add_user"
            className={`pro-input lg ${getFieldError("add_user") && "error"}`}
            {...formik.getFieldProps("add_user")}
            onChange={(e) => formik.setFieldValue("add_user", e.target.value)}
            error={getFieldError("add_user")}
            errorMessage={getFieldError("add_user")}
          />
          <button
            onClick={handleAddSelectedUser}
            className={`${Style.add_btn}`}
          >
            <span className="material-symbols-outlined x4"> add </span>
          </button>
        </div>
        <div>
        <div className={`${Style.number_badge_wrap} pro-mb-4`}>
          {formik?.values?.user_mobiles?.map((item, index) => (
            <div key={index} className={Style.badge}>
              {item}
              <span
                onClick={() => handleRemoveSelectedUser(index)}
                className="material-symbols-outlined"
              >
                close
              </span>
            </div>
          ))}
        </div>
        </div>
        {formik?.errors?.user_mobiles &&
          formik?.values?.user_mobiles?.length <= 0 && (
            <span className="error-text error error-img">
              {getFieldError("user_mobiles")}
            </span>
          )}
      </>
      <div className="col-6">
        <div className="pro-check-box pro-py-2">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="status"
              onBlur={formik?.handleBlur}
              checked={formik.values.status === 1}
              onChange={(e) =>
                formik.setFieldValue(`status`, e.target.checked ? 1 : 2)
              }
            />
            <label className="form-check-label" for="status">
              Status
            </label>
          </div>
          {getFieldError("status") && (
            <span className="error-text error error-img">
              {getFieldError("status")}
            </span>
          )}
        </div>
      </div>
      <div className="col-12 pro-d-flex pro-justify-end">
        <Button
          className="pro-btn-link lg pro-px-5"
          onClick={() => handleCloseModal()}
        >
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading" : ""
          }`}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default AddUsers;
